var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { composeHeaderParameter } from '../utils/paramHelper';
export class AssistantClient {
    constructor(endpoint, initData) {
        this.endpoint = endpoint;
        this.initData = initData;
    }
    getCookie() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = composeHeaderParameter(this.initData);
            try {
                yield fetch(`${this.endpoint}cookie`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: headers
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    fetchInitSessionInfo(trainingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = composeHeaderParameter(this.initData);
            try {
                const response = yield fetch(`${this.endpoint}${encodeURIComponent(trainingId)}/session`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: headers
                });
                const data = yield response.json();
                return data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    submitFeedback(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = composeHeaderParameter(this.initData);
            try {
                yield fetch(`${this.endpoint}submitFeedback`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: headers,
                    body: JSON.stringify(payload),
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }
}
